import { Avatar, Box, Tooltip, Typography } from '@mui/material';

function AttendeeRows({ currentAttendees }) {
  return currentAttendees.map(({ collarNumber, forenames, surname }) => {
    const name = [forenames, surname].filter(Boolean).join(' ').trim();

    return (
      <tr key={name}>
        <td style={{ whiteSpace: 'nowrap' }} align="left">
          {name}
        </td>
        <td style={{ whiteSpace: 'nowrap' }} align="left">
          {collarNumber}
        </td>
      </tr>
    );
  });
}

export function Attendees({ entry }) {
  return (
    <Box sx={{ display: 'inline-block' }}>
      <Tooltip
        title={
          entry.currentAttendees.length ? (
            <table>
              <thead>
                <tr>
                  <th align="left">Name</th>
                  <th align="right">Collar Number</th>
                </tr>
              </thead>
              <tbody>
                <AttendeeRows currentAttendees={entry.currentAttendees} />
              </tbody>
            </table>
          ) : (
            'No occupants detected'
          )
        }
      >
        <Avatar
          sx={{
            width: 22,
            height: 22,
            bgcolor:
              entry.currentAttendees.length >
              entry.attributes.requiredAttendance
                ? 'success.main'
                : 'error.main',
          }}
        >
          <Typography sx={{ fontSize: 14 }}>
            {entry.currentAttendees.length}
          </Typography>
        </Avatar>
      </Tooltip>
    </Box>
  );
}
